import { render, staticRenderFns } from "./TheSnapshotTableColDescriptionEdit.vue?vue&type=template&id=9723a8de&"
import script from "./TheSnapshotTableColDescriptionEdit.vue?vue&type=script&lang=js&"
export * from "./TheSnapshotTableColDescriptionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports